export default function FloorPlan({ className = "" }) {
  return (
    <svg viewBox="0 0 400 300" className={className} role="img" aria-label="Planimetria dimostrativa">
      <rect x="0" y="0" width="400" height="300" fill="#FDFBF7" />
      <g fill="none" stroke="#0F5C4A" strokeWidth="3">
        <rect x="20" y="20" width="360" height="260" />
        {/* vertical divisions */}
        <line x1="180" y1="20" x2="180" y2="160" />
        <line x1="180" y1="160" x2="380" y2="160" />
        <line x1="270" y1="160" x2="270" y2="280" />
        <line x1="180" y1="220" x2="270" y2="220" />
        {/* soggiorno / bathroom split */}
        <line x1="90" y1="160" x2="90" y2="280" />
      </g>
      {/* doors */}
      <g stroke="#0F5C4A" strokeWidth="2" fill="none" opacity="0.6">
        <path d="M180 90 a20 20 0 0 1 20 20" />
        <path d="M270 210 a18 18 0 0 1 18 18" />
        <path d="M90 210 a18 18 0 0 0 -18 18" />
      </g>
      <g fill="#1A1C1A" fontFamily="Outfit, sans-serif" fontSize="13" opacity="0.75">
        <text x="70" y="95" textAnchor="middle">Soggiorno</text>
        <text x="280" y="95" textAnchor="middle">Camera 1</text>
        <text x="325" y="225" textAnchor="middle">Camera 2</text>
        <text x="222" y="195" textAnchor="middle">Bagno</text>
        <text x="180" y="255" textAnchor="middle">Cucina</text>
        <text x="55" y="225" textAnchor="middle">Ingresso</text>
      </g>
      <text x="200" y="18" textAnchor="middle" fill="#0F5C4A" fontFamily="Outfit" fontSize="11" opacity="0.5">
        PLANIMETRIA INDICATIVA
      </text>
    </svg>
  );
}
